import { useSplitTreatments } from "@splitsoftware/splitio-react";

export type FeatureFlag =
  | "operations-client"
  | "linehaul-client"
  | "dock-automation-client"
  | "back-office-client"
  | "back-office-bod-19-global-search-client"
  | "operations-inbound-client"
  | "operations-outbound-client"
  | "osad-fe-mfe-client"
  | "assistant-fe-mfe-client"
  | "linehaul-employee-drivers-functionality"
  | "linehaul-rate-per-mile-client"
  | "linehaul-master-schedule-employee-drivers-client"
  | "linehaul-multi-week-client"
  | "settings-drivers-view-edit-client"
  | "dispatch-client"
  | "dispatch-routes-filter-client"
  | "linehaul-loadboard-pronotes-client"
  | "dispatch-stops-panel-client"
  | "dispatch-summary-panel-client"
  | "linehaul-loadboard-unassign-shipment-client"
  | "linehaul-loadboard-reassign-shipment-client"
  | "outbound-trailershub"
  | "dispatch-driver-latest-locations-client"
  | "linehaul-loadboard-trip-status-change-client"
  | "linehaul-loadboard-schedule-table-view"
  | "linehaul-loadboard-uccc-planning-client"
  | "inbound-unplanned-freight-incomplete-trailers-client"
  | "linehaul-reship-client"
  | "inbound-planning-grid-view-visibility-client"
  | "linehaul-merge-client"
  | "service-center-tabs"
  | "linehaul-client-global-menu"
  | "linehaul-load-plan-report-client"
  | "linehaul-master-schedule-form-v3"
  | "linehaul-loadboard-schedule-form-v3-client"
  | "linehaul-rollover-client"
  | "inbound-planning-print-shipment-icon-visibility-client"
  | "inbound-2967-unplanned-freight-new-design-client"
  | "linehaul-1506-service-center-overview-shipments-tab-client"
  | "linehaul-1437-end-of-shift-report-client"
  | "linehaul-1549-load-and-hold-on-new-entry-client"
  | "linehaul-1550-load-and-hold-icon-client"
  | "linehaul-1604-cancellations-report-client"
  | "linehaul-1504-shipments-stats-client"
  | "linehaul-1858-trip-shipments-source-client"
  | "outbound-OD-1463-published-linehaul-trips-client"
  | "outbound-OD-1514-show-current-location-column-client"
  | "dispatch-stops-panel-count-tooltip-client"
  | "dispatch-dis-1960-zone-preset-filter-client"
  | "linehaul-1442-cost-breakdown-client"
  | "dispatch-routes-panel-client"
  | "dispatch-643-assign-stop-client"
  | "dispatch-772-reassign-stop-client"
  | "dispatch-904-stop-card-client"
  | "outbound-OD-1587-show-door-number-on-trap-client"
  | "dispatch-798-shipment-details-documents-tab-client"
  | "dispatch-602-stop-details-panel-client"
  | "outbound-OD-1602-use-current-location-outbound-trip-client"
  | "linehaul-1902-disable-date-fields-on-enrt-client"
  | "dispatch-1051-route-selection-panel-client"
  | "inbound-3653-map-sidebar-left-client"
  | "linehaul-1823-conditional-reason-for-delay-client"
  | "inbound-3684-new-map-page-client"
  | "outbound-OD-1642-new-shipment-filter-multiple-statuses-client"
  | "outbound-OD-1438-recap-by-status-client"
  | "linehaul-2018-trip-optimization-client"
  | "outbound-OD-1706-swing-trailer-client"
  | "outbound-OD-1732-show-additional-info-load-trailer-client"
  | "outbound-OD-1771-show-bulk-reconcile-selected-shipments-client"
  | "dispatch-1326-route-assignment-preview-client"
  | "outbound-OD-1763-bypass-close-trailer-info-client"
  | "outbound-OD-1817-show-complete-doors-client"
  | "backend-green-endpoints-client"
  | "back-office-bod-198-navigation-home-client"
  | "back-office-bod-199-navigation-billing-client"
  | "back-office-bod-201-navigation-pricing-rating-client"
  | "back-office-bod-202-navigation-sales-client"
  | "back-office-bod-196-quick-quote-client"
  | "back-office-bod-83-quick-quote-v2-client"
  | "back-office-bod-195-rate-quote-client"
  | "back-office-bod-367-rate-quote-v2-client"
  | "back-office-bod-203-order-entry-client"
  | "back-office-bod-435-fuel-surcharge-navigation-client"
  | "inbound-3791-update-location-in-new-map-client"
  | "back-office-bod-230-side-navigation-menu-client"
  | "outbound-OD-1893-sortable-reconcile-shipment-table-client"
  | "back-office-bod-231-client-activity-client"
  | "back-office-bod-233-client-activity-shipments-client"
  | "back-office-bod-429-client-activity-quote-client"
  | "outbound-OD-1894-use-new-door-customization-tool-client"
  | "linehaul-2345-add-cost-accessorial-client"
  | "inbound-3855-remove-equipment-or-door-validation-client"
  | "inbound-3876-equipment-inventory-layout-client"
  | "operation-1733-dock-automation-client"
  | "dockauto-fe-mfe-client"
  | "inbound-3879-mexico-tooltip-client"
  | "inbound-3884-shipment-table-sort-order"
  | "dispatch-1762-split-stop-client"
  | "dispatch-truck-card-quick-message-client"
  | "linehaul-2431-transit-dashboard-client"
  | "linehaul-trip-list-client"
  | "linehaul-2548-trips-dashboard-delivered-client"
  | "operations-1580-user-endpoint-cache-client"
  | "outbound-OPS-4482-use-service-center-date-client"
  | "linehaul-2415-bulk-manifest-client"
  | "outbound-OPS-5586-arrive-trip-client"
  | "outbound-OPS-5583-use-current-plan-date-client"
  | "operations-3811-map-view-ux-enhancements"
  | "linehaul-2566-trip-context-menu-client"
  | "apex-DIS-2032-maintenance-client"
  | "dispatch-1883-reschedule-stop-client"
  | "outbound-OPS-5702-convert-city-trip-to-trap-client"
  | "operations-5594-CNCL-traps-treatment-client"
  | "dispatch-1766-routes-sorting-client"
  | "dispatch-1877-stops-sorting-client"
  | "operations-5589-remove-auto-sequence-in-past-dates-client"
  | "operations-5864-inbound-zod-parser-client"
  | "operations-5890-settings-routes-and-traps-pagination-client"
  | "linehaul-2723-notification-icon-client"
  | "linehaul-2548-bulk-request-client"
  | "linehaul-2488-request-status-button-client"
  | "linehaul-2489-trip-details-tab-client"
  | "linehaul-2102-history-tab-client"
  | "linehaul-2508-notes-tab-client"
  | "linehaul-2512-documents-tab-client"
  | "linehaul-2094-planning-trips-search-client"
  | "operations-5722-listing-equipments-dropdown-client"
  | "operations-5834-inbound-osad-client"
  | "inbound-5931-OSAD-assign-form-client"
  | "inbound-6343-OSAD-remove-edit-button-from-assign-dialog-client"
  | "dockauto-DOCK-1833-employees-list-client"
  | "access-control-DOCK-1926-biometrics-users-client"
  | "linehaul-2801-uc-cc-ofd-client"
  | "linehaul-2811-uc-cc-ofd-details-tab-client"
  | "linehaul-2859-trip-details-stops-client"
  | "dispatch-1878-insights-tab-client"
  | "back-office-bod-614-global-rates-navigation-client"
  | "operations-6016-handling-units-client"
  | "dispatch-dis-2499-stop-tile-shipment-tags-client"
  | "operations-5825-OSAD-tile-in-lane-details-client"
  | "back-office-bil-88-billing-dashboard-navigation-client"
  | "back-office-bil-95-billing-queue-navigation-client"
  | "back-office-blng-11-bill-change-navigation-client"
  | "back-office-bil-149-billing-change-requests-navigation-client"
  | "back-office-bod-771-lane-minimum-navigation-client"
  | "back-office-bod-791-high-cost-zipcodes-navigation-client"
  | "linehaul-2887-regions-v2-client"
  | "dispatch-dis-2475-reorder-stops-client"
  | "dispatch-2707-data-polling-client"
  | "operations-5832-OSAD-left-panel-lane-details-client"
  | "dispatch-dis-2500-route-tile-shipment-tags-client"
  | "back-office-bil-153-billing-exceptions-navigation-client"
  | "dispatch-dis-1041-routes-compare-mode-client"
  | "back-office-bod-725-accessorial-navigation-client"
  | "back-office-bod-861-rules-navigation-client"
  | "back-office-bod-1113-volume-rates-navigation-client"
  | "back-office-bod-965-rate-base-navigation-client"
  | "operations-5968-hyperlink-card-client"
  | "dispatch-2781-route-tab-client"
  | "dispatch-2781-messages-tab-client"
  | "operations-6021-trip-list-client"
  | "back-office-ttsl-169-navigation-transit-times-client"
  | "back-office-ttsl-92-transit-time-eol-service-centers-navigation-client"
  | "outbound-OPS-6050-allow-edit-clos-loads-update"
  | "operations-6222-appointment-setting-client"
  | "back-office-cs-279-pickup-review-navigation-client"
  | "ops-5967-active-routes-filter-client"
  | "linehaul-2826-uc-cc-ofd-documents-tab-client"
  | "linehaul-2819-uc-cc-ofd-history-tab-client"
  | "linehaul-2823-uc-cc-ofd-notes-tab-client"
  | "linehaul-3048-settings-rates-and-accessorial-navigation-client"
  | "back-office-ttsl-174-linehaul-transit-matrix-navigation-client"
  | "back-office-cust-74-disruption-command-center-navigation-client"
  | "back-office-ttsl-307-service-holidays-navigation-client"
  | "back-office-ttsl-357-global-holidays-navigation-client"
  | "outbound-OPS-6321-service-due-date-field-fix-enabled"
  | "outbound-OPS-6286-osad-remove-edit-button-enabled-client"
  | "dispatch-DIS-2528-stops-summary-v2-client"
  | "inbound-OPS-6636-in-use-door-block-cldk-status-server"
  | "operations-6627-equipment-inventory-sort-persistence-client"
  | "back-office-bil-320-cargo-claims-navigation-client"
  | "back-office-bil-321-cargo-claims-analyst-dashboard-navigation-client"
  | "back-office-bil-335-cargo-claims-performance-navigation-client"
  | "outbound-OPS-6597-same-door-different-lanes-fix-client"
  | "operations-6631-is-equipment-inventory-sort-fix-enabled-client"
  | "dispatch-DIS-3221-total-time-on-shift-enabled-client"
  | "inbound-6600-new-assign-endpoint-OSAD-client"
  | "operations-6287-yard-check-equipment-inventory-client"
  | "back-office-cust-136-navigation-account-profile-client"
  | "operations-OPS-6295-two-stops-client"
  | "dispatch-DIS-3172-websocket-event-client"
  | "dispatch-DIS-2651-reorder-suggested-stops-client"
  | "linehaul-3149-junction-setup-client"
  | "osad-oms-18-show-hide-oms-button-client"
  | "osad-oms-18-show-hide-osad-settings-client"
  | "linehaul-3199-linehaul-billing-client"
  | "outbound-6440-add-sealnumber-to-convert-to-trap-client"
  | "outbound-6454-add-change-trip-client"
  | "linehaul-3587-employee-cost-assumption-navigation-client"
  | "linehaul-3253-repower-client"
  | "linehaul-3261-rescue-trip-client"
  | "dispatch-3376-cancel-pickups-client"
  | "dispatch-DIS-3437-live-route-totals-client"
  | "OPS-6658-change-trip-workflow-fixes-client"
  | "radar-sls-66-radar-navigation-client"
  | "radar-sls-67-sale-radar-navigation-client"
  | "radar-sls-68-fleet-radar-navigation-client"
  | "radar-sls-69-agent-radar-navigation-client"
  | "linehaul-3536-daily-pickup-report-navigation-client"
  | "linehaul-3510-freight-on-hand-navigation-client"
  | "linehaul-3516-ucc-cc-reports-navigation-client"
  | "linehaul-lh-3644-uccc-ofd-appt-window-client"
  | "linehaul-3648-notes-sort-toggle-client"
  | "linehaul-lh-3503-trips-dashboard-planning-download-report-client"
  | "operations-OPS-6330-racks-client"
  | "linehaul-LH-3203-linehaul-billing-l-code-queue-tab-client"
  | "linehaul-LH-3211-linehaul-billing-m-code-queue-tab-client"
  | "linehaul-LH-3222-linehaul-billing-employee-queue-tab-client"
  | "linehaul-LH-3225-linehaul-billing-find-trip-tab-client";

export const useIsFeatureFlagEnabled = (feature: FeatureFlag) => {
  const { treatments, isReady } = useSplitTreatments({ names: [feature] });
  return isReady && treatments[feature].treatment === "on";
};
